import noop from 'lodash/noop';
import domEnums from 'app/dom_mutators/enums';

export default function hideCustomMinimizedButton() {
  const customButton = document.getElementById(domEnums.CUSTOM_BUTTON_ID);
  customButton ? customButton.classList.remove(domEnums.SHOW_CUSTOM_BUTTON) : noop();
}
